export const odiRankingsStub = {
    batsmen: {
        rank: [
            {
                id: "23456",
                rank: "1",
                name: "Virat Kohli",
                country: "India",
                rating: "870",
                points: "870",
                lastUpdatedOn: "2022-04-26",
                trend: "Flat",
                faceImageId: "170661"
            },
            // ... other batsmen
        ]
    },
    bowlers: {
        rank: [
            {
                id: "34567",
                rank: "1",
                name: "Jasprit Bumrah",
                country: "India",
                rating: "850",
                points: "850",
                lastUpdatedOn: "2022-04-26",
                trend: "Flat",
                faceImageId: "184118"
            },
            // ... other bowlers
        ]
    },
    allrounders: {
        rank: [
            {
                id: "45678",
                rank: "1",
                name: "Shakib Al Hasan",
                country: "Bangladesh",
                rating: "810",
                points: "810",
                lastUpdatedOn: "2022-04-26",
                trend: "Flat",
                faceImageId: "184119"
            },
            // ... other allrounders
        ]
    },
    teams: {
        rank: [
            {
                id: "2",
                rank: "1",
                name: "England",
                rating: "125",
                points: "3220",
                matches: "26"
            },
            // ... other teams
        ]
    }
};
